import { Image, TypeWrapper } from '@ahmdigital/ui';
import styled from 'styled-components';

import purpleBackgroundImage from './images/tongue-background.png';

export const OfferTongueWrapper = styled.div`
  align-items: center;
  background-color: transparent;
  background-image: url(\"${purpleBackgroundImage.src}\");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  border: none;
  display: flex;
  gap: 0.5rem;
  height: 3.5rem;
  justify-content: center;
  margin: 0 auto;
  padding: 0.75rem 0 0.5rem 0;
  text-align: center;
  width: 100%;
  width: 17.5rem;

  @media (min-width: ${({ theme }) => theme.media.md}) {
    padding: 0.5rem 0;
    width: 27.75rem;
  }
`;

export const OfferCopy = styled(TypeWrapper)`
  color: ${({ theme }) => theme.colors.purple};
  font-size: 1rem;
  padding-right: 2.25rem;
`;

export const OfferTag = styled(Image)`
  height: 1.75rem;
  margin-top: 0.25rem;
  padding-left: 2.25rem;
  transform: rotate(-7deg);
`;
